import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { DataHandler, StorageHandler, APIHandler, Image, SharingPopup } from 'C4';
import { storageKeys } from 'settings';

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'collateral', type, value, title).then(() => {
      });
    });
  });
};

const Collection = (props) => {
  const { content, header } = props;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(content).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: header,
  };

  return (
    <div className="collection__Container">
      <div className="collection__Container--title">
        <h3>{header}</h3>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="collection__Grid">
            {Object.values(content).map((item, index) => {
              const {
                pageID, image, title, url, type,
              } = item;
              if (type === 'pdf') {
                return (
                  <div onClick={() => trackShare('collectionItem', url, header + ': ' + title)} className="collection_Card pdfCollection" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                    <a
                      href={`https://stack.travpromobile.com/viewer.php?file=${url}#zoom=75`}
                      fancybox={`https://stack.travpromobile.com/viewer.php?file=${url}#zoom=75`}
                      data-options={JSON.stringify({
                        buttons: ['thumbs', 'share', 'close'],
                        share: {
                          tpl: renderToString(<SharingPopup url={url} />),
                        },
                      })}
                      caption={title}
                      data-fancybox-trigger={url}
                      data-fancybox={url}
                    >
                      <Image
                        key={url}
                        src={image}
                        gradient
                        onLoad={() => { this.setState({ loading: false }); }}
                      />
                      <div className="title">{title}</div>
                    </a>
                  </div>
                );
            }

            if (type === 'weblink') {
              return (
                <div onClick={() => trackShare('collectionItem', url, header + ': ' + title)} className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                  <a
                    href={url}
                    target="_blank"
                  >
                    <Image
                      key={url}
                      src={image}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                      href={url}
                      fancybox={url}
                      options={fancyOptions}
                      caption={title}
                    />
                    <div className="title">{title}</div>
                  </a>
                </div>
              );
          }


            if (type === 'infographic') {
              return (
                <div onClick={() => trackShare('collectionItem', url, header + ': ' + title)} className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                  <a
                    href={url}
                    fancybox={url}
                    data-options={JSON.stringify({
                      buttons: ['thumbs', 'share', 'close'],
                      share: {
                        tpl: renderToString(<SharingPopup url={url} />),
                      },
                    })}
                    caption={title}
                    data-fancybox-trigger={url}
                    data-fancybox={url}
                  >
                    <Image
                      key={url}
                      src={image}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                      href={url}
                      fancybox={url}
                      options={fancyOptions}
                      caption={title}
                    />
                    <div className="title">{title}</div>
                  </a>
                </div>
              );
          }


          if (type === 'videolink') {
            return (
              <div onClick={() => trackShare('collectionItem', url, header + ': ' + title)} className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                <a
                  href={url}
                  fancybox={url}
                  data-options={JSON.stringify({
                    buttons: ['thumbs', 'share', 'close'],
                    share: {
                      tpl: renderToString(<SharingPopup url={url} />),
                    },
                  })}
                  caption={title}
                  data-fancybox-trigger={url}
                  data-fancybox={url}
                >
                  <Image
                    key={url}
                    src={image}
                    gradient
                    onLoad={() => { this.setState({ loading: false }); }}
                    href={url}
                    fancybox={url}
                    options={fancyOptions}
                    caption={title}
                  />
                  <div className="title">{title}</div>
                </a>
              </div>
            );
        }

              return (
                <div onClick={() => trackShare('collectionItem', url, header + ': ' + title)} className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <Image
                      key={url}
                      src={image}
                      caption={title}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                    />
                    <div className="title">{title}</div>
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default Collection;

Collection.propTypes = {
  content: PropTypes.arrayOf.isRequired,
  header: PropTypes.string,
};

Collection.defaultProps = {
  header: '',
};
